module.exports = __webpack_public_path__ + "media/images/icons/file_icon-ee239c65fc541b2d35d0ca47eed27f34.svg";